import styled, { css } from 'styled-components';
import { layout, space } from 'styled-system';
import TypographyStyles from '../base/typographyStyles';

const CardImageStyles = styled.img`
  max-width: 4.5rem;
  max-height: 4.5rem;
`;

const CardImageWrapperStyles = styled.div`
  width: 4.5rem;
  height: 4.5rem;
  display: flex;
  align-items: center;
`;

const CardDataStyles = styled.div`
  align-self: center;
  margin-left: ${props => props.theme.space[2]};
`;

const CardStyles = styled.div`
  ${layout}
  ${space}

  cursor: pointer;
  display: flex;
  width: 100%;
  position: relative;

  ${props =>
    props.selected &&
    css`
      background: ${props.theme.colors.primary};
      ${TypographyStyles.HeadingStyles} {
        color: ${props.theme.colors.white};
      }
    `};
`;

CardStyles.ImageStyles = CardImageStyles;
CardStyles.ImageWrapperStyles = CardImageWrapperStyles;
CardStyles.DataStyles = CardDataStyles;

export default CardStyles;
